<template>
    <div style="max-width: 770px;">
        <div class="progress" style="height: 20px;">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{width: progress + '%'}">Searching...</div>
        </div>
        <div class="mt-4 text-left">
            Please wait while we process your application. This may take a few minutes.<br><br><strong>DO NOT</strong> close your browser, refresh the page or press the back button as this will interfere with your submission.
        </div>
    </div>
</template>

<script>

export default {
    name: 'Processing',
    title: 'Register | Processing',
    
    data() {
	  return {
          progress: 25,
          saving: false,
	  }
    },
    methods: {
        setProgress(){
            let progress = this.progress;
            switch(true){
                case (progress < 50):
                    this.progress += Math.floor(Math.random() * 7) + 3;
                break;
                case (progress < 90):
                    this.progress += Math.floor(Math.random() * 4) + 2;
                break;
                case (progress < 97):
                    this.progress += 2;
                break;
                default:
                    this.progress = 99;
            }
        },
        submitData(){
            this.progress = 99;
            this.$router.push({ path: '/registration/thankyou' });
            return;
        }
    },
    created(){
        setTimeout(this.setProgress, 1000);
        setInterval(this.setProgress, 2000);
        setTimeout(this.submitData, 10000);
    }
}
</script>

<style>
    
</style>